import {ChangeDetectionStrategy, Component} from '@angular/core';
import {TextInputComponent} from "../../../components/text-input/text-input.component";
import {FormBuilder, FormsModule, Validators} from '@angular/forms';
import {WaitingListRegistrationService} from "../../../services/waiting-list-registration.service";
import {ActivatedRoute, Router} from "@angular/router";
import {SubmitButtonComponent} from "../../../components/submit-button/submit-button.component";
import {definePreset} from "@primeng/themes";
import {MyPreset} from "../../../theme";
import {of, switchMap} from "rxjs";

@Component({
  selector: 'homey-waitlist-page',
  imports: [
    TextInputComponent,
    FormsModule,
    SubmitButtonComponent
  ],
  templateUrl: './waitlist-page.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class WaitlistPageComponent {
  protected readonly emailFormControl = this.fb.nonNullable.control('', [Validators.email]);
  constructor(
    private readonly fb: FormBuilder,
    private readonly waitingListRegistrationService: WaitingListRegistrationService,
    private readonly router: Router,
    private readonly route: ActivatedRoute) {
  }

  dt = definePreset(MyPreset, {
    root: {
      paddingY: '0',
      paddingX: '1rem',
      border: {
        radius: '0.5rem',
      },
      primary: {
        border: {
          color: '{orange.500}',
        },
        color: 'white',
        background: '{orange.500}',
        hover: {
          border: {
            color: '{orange.600}',
          },
          color: 'white',
          background: '{orange.600}',
        },
        active: {
          border: {
            color: '{orange.700}',
          },
          color: 'white',
          background: '{orange.700}',
        },
      }
    }
  })
  submitFunction = () => {
    if (this.emailFormControl.invalid) {
      return of(undefined);
    }

    return this.waitingListRegistrationService.addToWaitingList(this.emailFormControl.value).pipe(
      switchMap(() => this.router.navigate(['success'], {relativeTo: this.route, replaceUrl: true, queryParams: {email: this.emailFormControl.value}})),
    );
  }
}
